function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSijoitusGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.75 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sijoitus_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.34,11.92A4.35,4.35,0,1,0,27,7.58,4.33,4.33,0,0,0,31.34,11.92Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.76,9.39a1.38,1.38,0,0,0-1.94,0L34,14.19a3.81,3.81,0,0,0-5.4,0L24.87,9.4a1.39,1.39,0,0,0-1.94,0,1.41,1.41,0,0,0-.45,1.9L27,17a7.71,7.71,0,0,0-.32,2.18,7.36,7.36,0,0,0,.88,3.54v0l-.2,10.65a1.54,1.54,0,0,0,3.05.05l.15-8.27a3.59,3.59,0,0,0,.81.1,3.72,3.72,0,0,0,.88-.11l.12,8.29a1.43,1.43,0,0,0,1.54,1.31,1.46,1.46,0,0,0,1.51-1.38l-.16-10.65s0-.09,0-.14A7.38,7.38,0,0,0,36,19.18,8,8,0,0,0,35.72,17l4.49-5.72A1.39,1.39,0,0,0,39.76,9.39Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,31.76l.17-9.09a7.6,7.6,0,0,1-.56-5L21,13.05a1.76,1.76,0,0,1-.35-1.31.43.43,0,0,1,0-.05l-2.95-1a.65.65,0,0,0-.34,0,.61.61,0,0,0-.33,0L2.4,15.77c-.57.2-.78,1.13-.47,2.07s1,1.55,1.59,1.35l2.29-.8v8.09a6,6,0,0,0,5.87,6.06H23a5.73,5.73,0,0,0,2.07-.4A1.58,1.58,0,0,1,25,31.76Zm-3.84-6.48a1.1,1.1,0,0,1-1.08,1.11h-5.5a1.09,1.09,0,0,1-1.07-1.11V20.8a1.09,1.09,0,0,1,1.07-1.11h5.5a1.1,1.1,0,0,1,1.08,1.11Z",
    style: {
      fill: "#a0a0a0"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSijoitusGrey);
export default __webpack_public_path__ + "static/media/sijoitus_grey.866f456f465ec477353e1347bf237fcc.svg";
export { ForwardRef as ReactComponent };